<script lang="ts" setup>
import { computed } from 'vue'

import { useVoipRoomStore } from '../model/voip-room-store'
import { useDesktopViewport } from '../model/desktop-viewport.hook'
import LiveKitButtonShare from './livekit/LiveKitButtonShare.vue'

defineOptions({
  name: 'ButtonShare',
})

const voipRoomStore = useVoipRoomStore()

// Capability — getDisplayMedia is absent on iOS/iPadOS; viewport — a phone-sized screen
// can't run a share, and UA sniffing proved unreliable (it missed iPad entirely).
const isDesktopViewport = useDesktopViewport()
const isSupported = typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getDisplayMedia

const canShare = computed<boolean>(() => isSupported && isDesktopViewport.value && voipRoomStore.isLiveKitRoom)
</script>

<template>
  <LiveKitButtonShare v-if="canShare" />
</template>
